import { buildComponent } from '#components'

import './card-with-popup.css'

const CardWithPopup = buildComponent({
  name: 'card-with-popup',
  onConnected: (component) => {
    const triggerEl = component.querySelector<HTMLButtonElement>('.js-popup-trigger')
    const popupEl = component.querySelector<HTMLElement>('.js-popup')

    if (!triggerEl || !popupEl) return

    triggerEl.addEventListener('click', () => {
      const isVisible = component.classList.contains('popup-visible')

      if (isVisible) {
        component.classList.remove('popup-visible')

        popupEl.setAttribute('tabindex', '-1')
        popupEl.setAttribute('aria-hidden', 'true')
        triggerEl.setAttribute('aria-expanded', 'false')
        triggerEl.setAttribute('aria-label', 'Open popup')
        triggerEl.focus()

        return
      }

      component.classList.add('popup-visible')

      popupEl.setAttribute('tabindex', '0')
      popupEl.setAttribute('aria-hidden', 'false')
      popupEl.focus()
      triggerEl.setAttribute('aria-expanded', 'true')
      triggerEl.setAttribute('aria-label', 'Close popup')
    })
  }
})

declare global {
  interface HTMLElementTagNameMap {
    'card-with-popup': typeof CardWithPopup
  }
}
